document.body.addEventListener("click", function (e) {
    if (e.target && e.target.matches(".partners-load-more")) {
        e.preventDefault();
        const partners = document.querySelectorAll(".partners__item");
        if (partners) {
            [].forEach.call(partners, function (el) {
                el.classList.remove("hidden");
            });
            const btn = document.getElementById("partners__load-more");
            if (btn) {
                btn.remove();
            }
        }
    }
});
